import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Input from '../components/Input';
import Button from '../components/Button';
import {
  EnvelopeIcon,
  LockClosedIcon,
} from '@heroicons/react/24/outline';

const schema = yup.object().shape({
  email: yup.string().email('Invalid email address').required('Email is required'),
  password: yup.string().required('Password is required'),
});

const Login = () => {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    console.log('Login submitted:', data);

    // Simulate login success
    localStorage.setItem('token', 'dummy-token');
    navigate('/dashboard');
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100 dark:bg-neutral-900 px-4">
      <div className="w-full max-w-md space-y-8 bg-white dark:bg-neutral-800 p-8 rounded-lg shadow">
        <div>
          <h2 className="text-center text-2xl font-bold text-gray-900 dark:text-white">
            Sign in to your account
          </h2>
        </div>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <Input
            label="Email address"
            type="email"
            placeholder="you@example.com"
            leftIcon={<EnvelopeIcon className="h-5 w-5" />}
            {...register('email')}
            error={errors.email?.message}
          />

          <Input
            label="Password"
            type="password"
            placeholder="••••••••"
            leftIcon={<LockClosedIcon className="h-5 w-5" />}
            {...register('password')}
            error={errors.password?.message}
          />

          <div className="justify-between text-sm">
            <a href="#" className="text-emerald-600 hover:underline dark:text-emerald-400">
              Forgot your password?
            </a>
          </div>

          <Button
            type="submit"
            label="Sign in"
            className="w-full"
            variant="primary"
            disabled={isSubmitting}
          >
            Sign in
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Login;
